import React,{useState} from 'react';

type Props = {};

const IpblackListPage = (props: Props) => {
  const [ips, setIps] = useState('');

  const handleInputChange = (e: React.ChangeEvent<HTMLTextAreaElement>) => {
    setIps(e.target.value);
  };

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    console.log('Blacklisted IPs:', ips);
    alert('Blacklisted IPs Updated!');
  };

  const containerStyle = {
    maxWidth: '100%',
    margin: '0 auto',
    boxShadow: '6px 4px 10px 5px rgba(0, 0, 0, 0.2)',
    padding: '20px',
    borderRadius: '0px',
    height: '80%',
  };

  const textAreaStyle = {
    width: '100%',
    padding: '10px',
    marginBottom: '15px',
    borderRadius: '4px',
    border: '1px solid #ccc',
    fontSize: '12px',
    backgroundColor: '#F5F5F5',
    minHeight: '150px',
    resize: 'none' as const,
  };

  const buttonStyle = {
    padding: '10px 20px',
    border: 'none',
    borderRadius: '4px',
    backgroundColor: '#1173B7',
    color: 'white',
    cursor: 'pointer',
    fontSize: '12px',
    width: '20%',
    marginTop: '10px',
  };

  const titleStyle = {
    fontSize: '14px',
    marginBottom: '20px',
    textAlign: 'left' as const,
  };

  const descriptionStyle = {
    fontSize: '12px',
    marginBottom: '15px',
  };

  const exampleStyle = {
    fontSize: '12px',
    fontWeight: 'bold' as const,
    marginBottom: '10px',
  };

  const noteStyle = {
    fontSize: '10px',
    marginTop: '10px',
    color: 'gray',
  };

  const ipExampleStyle = {
    fontFamily: 'monospace',
    fontSize: '12px',
    marginBottom: '5px',
  };

  return (
    <div style={containerStyle}>
      <div style={{ width: '80%', textAlign: 'left', margin: '0 30px' }}>
        <h2 style={titleStyle}>Edit Your Blacklisted IPs:</h2>
        <p style={descriptionStyle}>
          IPs will match by the starting pattern of the IP provided. IP can follow the IPv4 or IPv6
          structures and should be on separate lines.
        </p>
        <p style={exampleStyle}>Examples:</p>
        <ul style={{ fontSize: '12px', marginBottom: '15px', paddingLeft: '20px' }}>
          <li>
            <span style={ipExampleStyle}>10.112.21.2</span> (Will block specific IPv4 address)
          </li>
          <li>
            <span style={ipExampleStyle}>10.124.6.</span> (Will block all IPv4 addresses starting with
            10.124.6.)
          </li>
          <li>
            <span style={ipExampleStyle}>10.1</span> (Will block all IPv4 addresses starting with 10.1,
            10.10, 10.100)
          </li>
          <li>
            <span style={ipExampleStyle}>2001:0db8:0000:0000:0000:0000:0000:0000</span> (Will block
            specific IPv6 address)
          </li>
          <li>
            <span style={ipExampleStyle}>2001:0db8:</span> (Will block all IPv6 addresses in this range)
          </li>
        </ul>
        <form onSubmit={handleSubmit}>
          <textarea
            value={ips}
            onChange={handleInputChange}
            placeholder="Enter IPs, one per line"
            style={textAreaStyle}
          />
          <p style={noteStyle}>Maximum of 3000 Entries</p>
          <button type="submit" style={buttonStyle}>
            Submit
          </button>
        </form>
      </div>
    </div>
  );
};

export default IpblackListPage;